const FAQDataEn = [
    {
        faqCat: "FAQ",
        faqData: [

            {
                questionId: 1,
                question: "Who is Masar Al-Tamayuz Information Technology?",
                answer: "Masar Al-Tamayuz is a Saudi digital marketing agency offering integrated advertising solutions including digital marketing, social media management, SEO, programming, printing, books, flyers, and corporate gifts. The company aims to help brands build a strong digital and offline presence through services that combine creativity, technology, and marketing expertise."
            },
            {
                questionId: 2,
                question: "What services does Masar Al-Tamayuz offer?",
                answer: (
                    <div>
                        <p>
                            Masar Al-Tamayuz provides a comprehensive range of digital marketing services to support brand growth in Saudi Arabia and the Gulf region. Our services include:
                        </p>
                        <ul>
                            <li>Multi-platform digital marketing</li>
                            <li>Social media account management</li>
                            <li>Search engine optimization (SEO)</li>
                            <li>Website design and development</li>
                            <li>Printing and design services</li>
                            <li>Digital and media content production</li>
                        </ul>
                        <p>
                            We aim to deliver customized solutions that meet our clients’ needs and help them achieve their marketing goals.
                        </p>
                    </div>
                )
            },
            {
                questionId: 3,
                question: "How much does social media account management cost?",
                answer: (
                    <div>
                        <p>
                            Pricing varies depending on the number of platforms, content type, and business size.<br />
                            Masar Al-Tamayuz offers flexible packages that include content creation, scheduling, and monthly performance reports.<br />
                            Request a customized quotation now.
                        </p>
                    </div>
                )
            },
            {
                questionId: 4,
                question: "Do you offer flexible packages for small and medium businesses?",
                answer: "Yes, we offer flexible plans that include account management, advertising campaigns, content creation, and SEO, with the ability to customize each plan according to the client’s objectives and budget."
            },
            {
                questionId: 5,
                question: "How do you plan advertising campaigns from concept to execution?",
                answer: (
                    <div>
                        <p>Campaigns go through several stages:</p>
                        <ol className="list-decimal">
                            <li>Market analysis and competitor research.</li>
                            <li>Studying the target audience.</li>
                            <li>Developing the strategy and selecting suitable platforms.</li>
                            <li>Creating engaging ad content and launching the campaign.</li>
                            <li>Monitoring performance and optimizing results to achieve the highest ROI.</li>
                        </ol>
                    </div>
                )
            },
            {
                questionId: 6,
                question: "Do you handle full content creation (text, images, videos) or only part of it?",
                answer: "Yes, we handle full content production including text, images, and videos, with the ability to execute complete campaigns including paid ads and account management."
            },
            {
                questionId: 7,
                question: "Which social media platforms does Masar Al-Tamayuz cover?",
                answer: "Instagram, Snapchat, TikTok, Twitter (X), Facebook, and LinkedIn. We offer full management including content creation, scheduling, follower engagement, and performance analysis to ensure the best marketing results."
            },
            {
                questionId: 8,
                question: "Do your services include paid ads or only organic posting?",
                answer: "Our services include both paid advertising and organic posting. The balance between them depends on the available budget and the client’s goals to achieve the best results."
            },
            {
                questionId: 9,
                question: "How do you ensure the content aligns with Saudi culture and values?",
                answer: "We study the target audience and tailor strategies for each segment, then review all content before publishing to ensure cultural relevance and local alignment."
            },
            {
                questionId: 10,
                question: "Do you have examples or case studies from previous clients?",
                answer: (
                    <p>
                        Yes, Masar Al-Tamayuz has a collection of examples and case studies from successful projects across various industries.<br />
                        Upon request, we provide relevant examples or studies based on the client’s field to demonstrate our expertise and results.
                    </p>
                )
            },
            {
                questionId: 11,
                question: "Do you offer English or bilingual content as part of your services?",
                answer: "Yes, we offer bilingual content services (Arabic and English), including copywriting, post design, and campaign management."
            },
            {
                questionId: 12,
                question: "When can I expect results from digital marketing campaigns?",
                answer: (
                    <p>
                        Engagement results appear within the first few weeks of launching the campaign, while measurable outcomes and ROI typically require 2 to 3 months, with regular performance reports.<br />
                        Goals are defined in the strategy and monitored continuously to ensure optimal results.
                    </p>
                )
            },
            {
                questionId: 13,
                question: "How do you communicate and coordinate with clients?",
                answer: "We offer direct and effective communication through regular meetings, monthly reports, and instant messaging to ensure accurate campaign execution and achieving brand objectives."
            },
            {
                questionId: 14,
                question: "What digital marketing packages do you offer?",
                answer: "We offer flexible packages designed to achieve brand objectives such as increasing engagement, reaching the target audience, and enhancing digital presence, with the ability to customize each package based on the client’s goals and digital strategy."
            },
            {
                questionId: 15,
                question: "How do I choose the right digital marketing agency in Riyadh or Saudi Arabia?",
                answer: (
                    <div>
                        <p>When choosing a digital marketing agency, it is recommended to consider several factors:</p>
                        <ul className="list-disc">
                            <li>Types of services and expertise to ensure they match your marketing goals.</li>
                            <li>Track record and case studies to confirm the agency’s ability to deliver results.</li>
                            <li>Package flexibility and regular reports for performance tracking and continuous improvement.</li>
                            <li>Cultural and local value alignment to ensure campaign success in the Saudi market.</li>
                        </ul>
                        <p className="fw-bold">
                            Masar Al-Tamayuz Information Technology provides all these standards with integrated services that support business growth.
                        </p>
                    </div>
                )
            }
        ]
    },

    // -----------------------------------------------------------
    // PRINT FAQ
    // -----------------------------------------------------------

    {
        faqCat: "FAQ_Print",
        faqData: [

            {
                questionId: 1,
                question: "What types of printing does Masar Al-Tamayuz offer?",
                answer: "We provide all types of commercial and professional printing, including offset printing for books and magazines, digital printing for small quantities, and high-quality packaging and production services."
            },
            {
                questionId: 2,
                question: "Can design and printing be completed at the same time?",
                answer: "Yes, our in-house design team prepares print-ready files according to approved technical specifications, ensuring accurate colors, proper dimensions, and fast delivery without relying on external parties."
            },
            {
                questionId: 3,
                question: "How long does it take to receive my order?",
                answer: "It depends on the project type, but typically ranges from 3 to 7 working days after final design approval, with urgent service available for rush projects."
            },
        ]
    },

    // -----------------------------------------------------------
    // BOOKS FAQ
    // -----------------------------------------------------------

    {
        faqCat: "FAQ_Books",
        faqData: [

            {
                questionId: 1,
                question: "Can an independent author publish their book through you?",
                answer: "Absolutely. We provide integrated solutions for authors starting from design and review all the way to printing and local/international distribution through online platforms and bookstores."
            },
            {
                questionId: 2,
                question: "Does Masar handle ISBN and legal deposit registration?",
                answer: "Yes, we provide legal deposit and ISBN registration in cooperation with the Saudi Ministry of Media to officially document publishing rights."
            },
            {
                questionId: 3,
                question: "Can you market and distribute the book after printing?",
                answer: "Yes, we offer digital and offline marketing and distribution plans including online stores, book fairs, and paid advertising campaigns."
            },
        ]
    },

    // -----------------------------------------------------------
    // WEB FAQ
    // -----------------------------------------------------------

    {
        faqCat: "FAQ_Web",
        faqData: [

            {
                questionId: 1,
                question: "What types of websites does Masar Al-Tamayuz develop?",
                answer: "We develop corporate, commercial, educational, and e-commerce websites using professional coding optimized for all devices and search engines."
            },
            {
                questionId: 2,
                question: "Do the services include hosting, domain, and technical support?",
                answer: "Yes, we provide full packages including domain registration, secure hosting, updates, and ongoing maintenance to ensure stability and performance."
            },
            {
                questionId: 3,
                question: "How long does it take to develop a website?",
                answer: "Development usually takes 3 to 6 weeks depending on the amount of content and required features, with partial deliveries for review and approval."
            },
        ]
    },

    // -----------------------------------------------------------
    // SYSTEMS FAQ
    // -----------------------------------------------------------

    {
        faqCat: "FAQ_Systems",
        faqData: [

            {
                questionId: 1,
                question: "What types of systems can you develop?",
                answer: "We develop enterprise management systems, mobile applications, e-commerce platforms, and booking/payment systems using the latest technologies."
            },
            {
                questionId: 2,
                question: "Do you provide support and maintenance after delivery?",
                answer: "Yes, we provide free technical support during the warranty period, along with optional annual maintenance contracts including security updates and continuous development."
            },
            {
                questionId: 3,
                question: "How is the cost of a software project determined?",
                answer: "Pricing is based on a detailed analysis of the client’s needs, the required features, and the number of development stages. A full technical and financial proposal is provided before starting."
            },
            {
                questionId: 4,
                question: "How can I contact Masar Al-Tamayuz Information Technology?",
                answer: (
                    <div>
                        <p>
                            Our team is always ready to assist you in choosing the service that best fits your marketing goals.
                            Whether you're looking for social media management, website design, or printing and publishing services, you can contact us in the following ways:
                        </p>

                        <ul className="list-disc">
                            <li>Via WhatsApp for quick inquiries.</li>
                            <li>Via email for proposals and business collaborations.</li>
                            <li>
                                Through the contact form on our website to select the required service and send your details directly.
                            </li>
                        </ul>

                        <p>
                            We are happy to hear from you anytime, and we will respond promptly with the best solution for your needs.
                        </p>
                    </div>
                )
            },
        ]
    },
];

export default FAQDataEn;
